import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {
    GDLiveAppContentWrapper,
    FlexMainWrapper,
    AppColumnWrapper,
    GDAppWrapper
} from './GamedayScaffold.style';
import GamedayDataContainer from './Gameday/containers/GamedayDataContainer';
import HeaderScoreboard from './HeaderScoreboard';
import SingleAdDataContainer from '@gameday/components/Ads/containers/SingleAdDataContainer';

const GamedayScaffold = ({
    componentMap
}) => {
    const {
        footer,
        ads,
        tracking,
        pagetitle,
        scoreboard,
        header
    } = componentMap;

    return (
        <>
           {ads && <componentMap.ads key={'ads'}/>}
           {tracking && <componentMap.tracking key={'tracking'}/>}
           {pagetitle && <componentMap.pagetitle key={'pagetitle'} />}
           <SingleAdDataContainer type={'topBanner'} />
            <GDLiveAppContentWrapper>
                <FlexMainWrapper>
                    <AppColumnWrapper>
                        <HeaderScoreboard componentMap={componentMap} />
                        <GDAppWrapper>
                            <GamedayDataContainer />
                        </GDAppWrapper>
                    </AppColumnWrapper>
                </FlexMainWrapper>
            </GDLiveAppContentWrapper>
            {footer && <componentMap.footer />}
        </>
    );
};

GamedayScaffold.propTypes = {
    componentMap: PropTypes.object
};

export default memo(GamedayScaffold);
